// src/design/forms/datepicker/calendar-engine/use-cases/english_date/get_first_day_of_the_month.ts
var e = (e) => {
	let t = e.getFullYear(), n = e.getMonth();
	return new Date(t, n, 1).getDay();
};
export { e as get_first_day_of_the_month };

//# sourceMappingURL=get_first_day_of_the_month.js.map